export default __webpack_public_path__ + "static/media/Maharaja021.ed508e90.jpg";